import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-form-flex',
    template: `
      <div
        class="flex-container"
        [class.xs-column]="props.fxLayoutXs !== 'row'"
        [style.flex-direction]="props.fxLayout || 'row'"
        [style.gap]="calculateGap(props)"
        >
        @for (f of field.fieldGroup; track f) {
          <formly-field
            class="flex-item"
            [style.--flex-width]="(f.props.fxFlex || 100) + '%'"
            [style.--flex-width-xs]="(f.props.fxFlexXs || 100) + '%'"
            [class.ml2]="f.props.fxLayoutGapXs"
            [field]="defaultField(f)">
          </formly-field>
        }
      </div>
      `,
    standalone: false
})
export class FlexLayoutType extends FieldType implements OnInit {

  ngOnInit(): void {
    this.field.fieldGroup = this.field.fieldGroup.map(fg => {
      return Object.assign(fg, { props: { appearance: 'outline', ...fg.props } });
    });
  }

  public calculateGap(props: any): string {
    const { fxLayoutGap, fxLayout } = props;

    // Se for coluna explicitamente, zera (comportamento legado comum do fxLayout)
    if (fxLayout === 'column') {
      return '0px';
    }

    // Retorna o valor ou o padrão. Garante que tenha unidade (px) se for só número.
    return fxLayoutGap ? fxLayoutGap : '24px';
  }

// Crie essa função se ela não existir, para alimentar o --gap-xs
  public calculateGapXs(props: any): string {
    // Se no mobile for coluna (padrão), talvez você queira gap 0 ou um gap menor (16px)
    if (props.fxLayoutXs === 'column') {
      return '0px'; // Ou '16px' se quiser espaçamento vertical
    }
    // Se tiver um gap específico para XS definido nas props, usa ele, senão 0 ou padrão
    return props.fxLayoutGapXs || '16px';
  }

  public defaultField(field) {
    return field;
  }

  private _isMobile(): boolean {
    return window.innerWidth <= 600;
  }


}
